import { PsychologicalDocumentsUseCase } from '../../../../data/usecases'
import { makeAxiosHttpClient } from '../../../factories'

type fetchRecordModel = {
  id: string | number
}

export const fetchRecord = ({ id }: fetchRecordModel) => {
  return new PsychologicalDocumentsUseCase(
    `/relatorio/load/${id}`,
    makeAxiosHttpClient()
  )
}

export const saveRecord = ({ id }: fetchRecordModel) => {
  return new PsychologicalDocumentsUseCase(
    `/relatorio/save/${id}`,
    makeAxiosHttpClient()
  )
}

export const updateRecord = ({ id }: fetchRecordModel) => {
  return new PsychologicalDocumentsUseCase(
    `/relatorio/update/${id}`,
    makeAxiosHttpClient()
  )
}
